module.exports = __webpack_public_path__ + "assets/pride-logo-76e867.svg";